export type UserActions = Record<string, string[]>;

export const normalizePermission = (value: string): string => (value || '').replace(/_/g, '').toUpperCase();

function actionsOf(permission: string, userActions: UserActions): string[] | undefined {
  const moduleName = Object.keys(userActions || {}).find((key) => normalizePermission(key) === permission);
  return moduleName ? userActions[moduleName] || [] : undefined;
}

/** Regra da sidebar: o item aparece se o usuário tem a permissão de menu e as ações exigidas pelo módulo. */
export function canSeeMenuItem(permission: string | undefined, menuPermissions: string[], userActions: UserActions): boolean {
  if (!permission) return true;

  const normalized = normalizePermission(String(permission));
  if (!menuPermissions.includes(normalized)) return false;

  const actions = actionsOf(normalized, userActions);
  if (!actions) return false;

  if (normalized === 'MASTEREVENT' || normalized === 'EVENT' || normalized === 'PUBLICACQUIRERTRANSACTION') {
    return actions.includes('index');
  }

  if (normalized === 'ATTENDEEREFUND') {
    return actions.includes('index') || actions.includes('update');
  }

  return actions.includes('create') && actions.includes('update');
}

export function canCreate(permission: string, userActions: UserActions): boolean {
  return !!actionsOf(normalizePermission(permission), userActions)?.includes('create');
}
